import request from '@/utils/request.js';
import { encryptext, decrypinfo, decryptext,} from '@/utils/JK.js';
import common from '@/utils/common.js';
import { Session } from '@/utils/storage.js';
import upload from '@/utils/Upload.js';



//查看客户组操作日志；
async function SeeMemberLog(PageNo, PageSize){
    const info = decrypinfo(Session.get("Hasee"));
    var val    = {
        OperatorID: info.AccountInfo.OperatorID,
        AccountID: info.AccountInfo.AccountID,
        PageNo: PageNo,
        PageSize: PageSize,
        UserType: 1,
        UserID: info.AccountInfo.GroupID,
    }
    const url  = 'vip_modify_query';
    const token = await upload.GetToken();
    if(!token) return false;
    
    let data = encryptext(val,url,info);
    let res  = await request({url:url,method:'post',data,realme:token});

    if(res){
        const resData = await decryptext(res.Data,info);
        if(resData){
            if( resData.SuccStat === 0 ){
                return resData;
            }else{
                common.ErrorMeeage(resData);
            }
        }
    }
    return false;
}


export default{
    SeeMemberLog
}